import React, { useMemo } from "react";
import { AiOutlineEye } from "react-icons/ai";
import ServerDataGrid from "../../../../../views/pages/manage/common/data-grid/ServerDataGrid";
import { CourseDetailsPopupById } from "../../../../../views/pages/manage/unAssigned/studentCharges/common";
import ReceiptStatusChip from "../../components/ReceiptStatusChip";
import { getFormattedAmount } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

 const formatDate = (dateString, includeTime = false) => {
  if (!dateString) return "-";
  const options = { year: "numeric", month: "2-digit", day: "2-digit" };
  if (includeTime) {
    options.hour = "2-digit";
    options.minute = "2-digit";
    options.hour12 = true;
  }
  return new Date(dateString)
    .toLocaleDateString("en-GB", options)
    .replace(",", "");
};

const ReceiptsList = ({
  rows,
  loading,
  pagination,
  onPageChange,
  onPageSizeChange,
  selectedIds,
  onSelectionChange,
}) => {
  const handleViewReceipt = (row) => {
    alert(`Viewing receipt for: ${row.student}`);
  };

  // Memoize columns to prevent unnecessary re-renders
  const columns = useMemo(
    () => [
      {
        key: "psid",
        label: "PSID",
        width: 120,
        render: (value) => (
          <span
            style={{
              color: "#00B0F5",
              cursor: "pointer",
              textDecoration: "none",
            }}
            onClick={() =>
              window.open(`/#/admin/edp/studentDetails/${value}`, "_blank")
            }
          >
            {value}
          </span>
        ),
      },
      { key: "applicationId", label: "Application Id", sortable: true, width: 100 },
      { key: "studentName", label: "Student name", sortable: true, width: 140 },
      { key: "paymentMode", label: "Type", sortable: true, width: 90 },

      {
        key: "courseId",
        label: "Course ID",
        width: 120,
        render: (value, row) => (
          <span title={row.courseName ?? ""}>
            {value}
            <CourseDetailsPopupById
              courseId={value}
              placement="left-end"
              cta={<AiOutlineEye className="ml-2" />}
            />
          </span>
        ),
      },
      { key: "term", label: "Term", width: 80 },
      { key: "receiptNo", label: "Receipt No.", width: 200 },
      {
        key: "receiptDate",
        label: "Receipt Date & Time",
        width: 170,
        sortable: true,
        render: (value) => formatDate(value, true),
      },
      { key: "createdBy", label: "Cashier ID", width: 130 },
      {
        key: "lastUpdatedOn",
        label: "Last Updated On",
        width: 180,
        render: (value) => formatDate(value, true),
      },
      // {
      //   key: "approvedOn",
      //   label: "Approved On",
      //   width: 160,
      //   render: (value) => formatDate(value, true),
      // },
      {
        key: "status",
        label: "Status",
        width: 140,
        pinned: true,
        render: (value) => <ReceiptStatusChip status={value} />,
      },
      {
        key: "amountCollected",
        label: "Amt Collected",
        sortable: true,
        pinned: true,
        width: 150,
        align: "right",
        render: (value) => (
          <b style={{ color: "#0A942B" }}>{getFormattedAmount(value)}</b>
        ),
      },
    ],
    []
  );

  return (
    <ServerDataGrid
      rows={rows}
      loading={loading}
      columns={columns}
      rowKey="id"
      pagination={pagination}
      onPageChange={onPageChange}
      onPageSizeChange={onPageSizeChange}
      selectable={true}
      selectedIds={selectedIds}
      onSelectionChange={onSelectionChange}
    />
  );
};

export default ReceiptsList;
